import { Component } from '@angular/core';

@Component({
    selector: 'app-toolbar-filter-section',
    templateUrl: './toolbar-filter-section.component.html',
    styleUrls: ['./toolbar-filter-section.component.scss'],
    standalone: false
})
export class ToolbarFilterSectionComponent {}
